<template>
    <restaurants-map-section
        class="restaurants-map-section-module"
    />
</template>

<script>
    import RestaurantsMapSection from '../../../organisms/RestaurantsMapSection/RestaurantsMapSection';

    export default {
        name: 'restaurants-map-section-module',

        components: { RestaurantsMapSection },

        props: {
            attributes: {
                type: Object,
                default: () => ({}),
            },
        },
    };
</script>
